import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouteReusableStrategy} from './route-reusable-strategy';
import {RouteReuseStrategy, RouterModule} from '@angular/router';
import {ErrorHandlerInterceptor} from './http-interceptor/error-handler.interceptor';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {TranslateModule} from '@ngx-translate/core';
import {ApiPrefixInterceptor} from './http-interceptor/api-prefix.interceptor';


@NgModule({
    imports: [CommonModule, HttpClientModule, TranslateModule, RouterModule],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiPrefixInterceptor,
            multi: true,
        },

        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorHandlerInterceptor,
            multi: true,
        },
        {
            provide: RouteReuseStrategy,
            useClass: RouteReusableStrategy,
        },
    ],
})
export class CoreModule {
}
